import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface ProtectedRouteProps {
    children: React.ReactNode;
    requireAdmin?: boolean;
    requireApproval?: boolean;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
    children,
    requireAdmin = false,
    requireApproval = true,
}) => {
    const { isAuthenticated, isAdmin, isApproved, isLoading } = useAuth();
    const location = useLocation();

    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-accent"></div>
            </div>
        );
    }

    if (!isAuthenticated) {
        const loginPath = requireAdmin ? "/admin/login" : "/login";
        return <Navigate to={loginPath} state={{ from: location }} replace />;
    }

    if (requireAdmin && !isAdmin) {
        return <Navigate to="/" replace />;
    }

    // Rediriger vers la page d'attente si l'utilisateur n'est pas approuve
    if (requireApproval && !isApproved && !isAdmin) {
        return <Navigate to="/pending-approval" replace />;
    }

    return <>{children}</>;
};

export default ProtectedRoute;
